{
  "elementLibrary": {
    "productName": "Título del producto",
    "cargaHoraria": "Carga horaria",
    "instrutor": "Nombre del instructor",
    "studentName": "Nombre del miembro",
    "issuedAt": "Fecha de emisión",
    "completionDate": "Fecha de finalización del curso",
    "hash": "Hash",
    "media": "Nota media del alumno",
    "documento": "Documento del miembro",
    "certText": "Texto de certificación",
    "concludeText": "Texto de finalización",
    "text": "Texto libre"
  },
  "dateFormats": {
    "dateTime": "dd/MM/yyyy HH:mm",
    "date": "dd/MM/yyyy"
  },
  "list": {
    "title": "Certificados",
    "subtitle": "Gestiona tus certificados y emisiones",
    "tabs": {
      "created": "Certificados creados",
      "history": "Historial de emisiones"
    },
    "deleteConfirm": {
      "title": "Eliminar certificado",
      "description": "¿Seguro? Las plantillas con emisiones no se pueden eliminar.",
      "confirm": "Eliminar"
    },
    "revokeConfirm": {
      "title": "Revocar certificado",
      "description": "El certificado dejará de ser válido en la verificación pública.",
      "confirm": "Revocar"
    },
    "toasts": {
      "deleted": "Certificado eliminado",
      "deleteError": "Error al eliminar",
      "revoked": "Certificado revocado",
      "revokeError": "Error al revocar",
      "linkCopied": "Enlace copiado",
      "copyError": "No se pudo copiar"
    },
    "created": {
      "searchPlaceholder": "Busca por título o código",
      "create": "Crear certificado",
      "columns": {
        "code": "CÓD",
        "certificate": "CERTIFICADO",
        "products": "PRODUCTOS",
        "mec": "MEC",
        "createdAt": "CREADO EL",
        "issued": "EMITIDOS"
      },
      "actions": {
        "edit": "Editar certificado",
        "delete": "Eliminar"
      },
      "empty": "No hay certificados creados"
    },
    "history": {
      "searchPlaceholder": "Buscar por miembro, email o código",
      "issue": "Emitir certificado",
      "columns": {
        "id": "ID",
        "member": "MIEMBRO",
        "product": "PRODUCTO",
        "date": "FECHA",
        "certificate": "CERTIFICADO"
      },
      "revoked": "Revocado",
      "actions": {
        "view": "Ver certificado",
        "goToProfile": "Ir al perfil del miembro",
        "copyLink": "Copiar enlace",
        "revoke": "Revocar certificado"
      },
      "empty": "Aún no hay emisiones"
    },
    "pagination": {
      "summary": "Página {{page}} de {{totalPages}} ({{total}})",
      "previous": "Anterior",
      "next": "Siguiente"
    }
  },
  "editorPage": {
    "toasts": {
      "saved": "Configuración guardada",
      "saveError": "Error al guardar"
    },
    "back": "Volver",
    "title": "Editor de certificado",
    "untitled": "Certificado",
    "save": "Guardar configuración",
    "fields": {
      "title": "Título",
      "workload": "Carga horaria",
      "workloadPlaceholder": "ej.: 40 horas",
      "mec": "Sello MEC",
      "allowReissue": "Permitir reemisión"
    },
    "products": {
      "title": "Contenidos asociados ({{count}})",
      "searchPlaceholder": "Buscar contenido..."
    }
  },
  "createDialog": {
    "validation": {
      "nameMin": "El título debe tener al menos 2 caracteres"
    },
    "yes": "Sí",
    "no": "No",
    "toasts": {
      "created": "Certificado creado",
      "createError": "Error al crear el certificado"
    },
    "title": "Crear certificado",
    "description": "Configura el certificado. El editor se abrirá a continuación.",
    "nameLabel": "Título del certificado *",
    "namePlaceholder": "Ej.: Certificado de finalización",
    "mecQuestion": "¿El certificado tendrá sello MEC?",
    "reissueQuestion": "¿Permitir la reemisión del certificado?",
    "productsLabel": "Seleccionar contenidos para este certificado",
    "selectedCount_one": "{{count}} seleccionado",
    "selectedCount_zero": "{{count}} seleccionados",
    "selectedCount_other": "{{count}} seleccionados",
    "searchPlaceholder": "Buscar contenido...",
    "noProducts": "No se encontró ningún contenido",
    "cancel": "Cancelar",
    "submitting": "Creando...",
    "submit": "Crear certificado"
  },
  "issueDialog": {
    "validation": {
      "selectProduct": "Selecciona un contenido",
      "memberRequired": "Indica el miembro (ID, nombre o email)"
    },
    "toasts": {
      "issued": "Certificado emitido",
      "issueError": "Error al emitir el certificado"
    },
    "title": "Emitir certificado",
    "description": "Elige el contenido e indica el miembro.",
    "memberLabel": "Miembro (ID, nombre o email) *",
    "memberPlaceholder": "Ej.: maria@email.com",
    "productLabel": "Contenido *",
    "searchPlaceholder": "Buscar contenido...",
    "noProducts": "No se encontró ningún contenido",
    "cancel": "Cancelar",
    "submitting": "Emitiendo...",
    "submit": "Emitir certificado"
  },
  "userTab": {
    "title": "Certificados ({{count}})",
    "revoke": "Revocar",
    "empty": "Este miembro aún no tiene certificados"
  },
  "visualEditor": {
    "toasts": {
      "uploadSuccess": "Archivo subido",
      "uploadError": "Error al subir el archivo"
    },
    "panel": {
      "elements": "Elementos",
      "others": "Otros",
      "image": "Imagen"
    },
    "toolbar": {
      "background": "Fondo",
      "backgroundColor": "Color de fondo",
      "backgroundImage": "Imagen de fondo",
      "remove": "Quitar",
      "uploadFont": "Subir fuente",
      "font": "Fuente"
    },
    "canvasHint": "Arrastra para posicionar. Haz clic para seleccionar y usa los tiradores verdes para redimensionar.",
    "inspector": {
      "image": "Imagen",
      "text": "Texto",
      "textLabel": "Texto",
      "font": "Fuente",
      "size": "Tamaño",
      "color": "Color",
      "weight": "Grosor",
      "weights": {
        "normal": "Normal",
        "semibold": "Seminegrita",
        "bold": "Negrita",
        "black": "Black"
      },
      "alignment": "Alineación",
      "align": {
        "left": "Alinear a la izquierda",
        "center": "Centrar",
        "right": "Alinear a la derecha"
      },
      "width": "Ancho",
      "height": "Alto",
      "auto": "auto",
      "replaceImage": "Cambiar imagen",
      "uploadImage": "Subir imagen",
      "empty": "Selecciona un elemento en el lienzo para editarlo."
    }
  },
  "elementDefaults": {
    "certText": "Certificamos que el alumno ha completado con éxito el contenido.",
    "concludeText": "Completado con éxito en la plataforma.",
    "text": "Nuevo texto"
  }
}
